module.exports = new __parcel__URL__("bk55_chip.f0c9965c.png").toString();